// extracted by mini-css-extract-plugin
export default {"main":"Landingscreen_main__H6Kus","router":"Landingscreen_router__l8wpT"};